module.exports = __webpack_public_path__ + "media/images/squared-4t-f0c614f17174f1e1797da999c21461ed.png";